import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {AsyncTaskStatus} from "../../shared/dtos";
import {LegalNoticeDTO, PaginatedEntityList} from "../../api/dtos";

export interface NoticeState {
    allPaginatedLegalNotices: PaginatedEntityList<LegalNoticeDTO> | null;
    loadLegalNoticesTaskStatus: AsyncTaskStatus | null;
    updateNoticeStatusTaskStatus: AsyncTaskStatus | null;
    deleteNoticeTaskStatus: AsyncTaskStatus | null;
}

const initialState: NoticeState = {
    allPaginatedLegalNotices: null,
    deleteNoticeTaskStatus: null,
    loadLegalNoticesTaskStatus: null,
    updateNoticeStatusTaskStatus: null
};

const noticeSlice = createSlice({
    name: 'notice',
    initialState,
    reducers: {
        setLoadLegalNoticesTaskStatus: (state, action: PayloadAction<AsyncTaskStatus | null>) => {
            state.loadLegalNoticesTaskStatus = action.payload;
        },
        setAllPaginatedLegalNotices: (state, action: PayloadAction<PaginatedEntityList<LegalNoticeDTO> | null>) => {
            state.allPaginatedLegalNotices = action.payload;
        },
        setUpdateNoticeStatusTaskStatus: (state, action: PayloadAction<AsyncTaskStatus | null>) => {
            state.updateNoticeStatusTaskStatus = action.payload;
        },
        setDeleteNoticeTaskStatus: (state, action: PayloadAction<AsyncTaskStatus | null>) => {
            state.deleteNoticeTaskStatus = action.payload;
        }
    }
});

export const {
    setAllPaginatedLegalNotices,
    setLoadLegalNoticesTaskStatus,
    setUpdateNoticeStatusTaskStatus,
    setDeleteNoticeTaskStatus
} = noticeSlice.actions;

export default noticeSlice.reducer;
